import { Item } from '@sitecore-content-sdk/nextjs';
import { Data } from '../../../.generated/Foundation.GMI.model';

type EnumParam = {
  value: {
    value: string;
  };
};

type OotbEnum = {
  fields?: {
    Value?: {
      value: string;
    };
  };
};

type EnumOrItem = Data.Enums.Gmienum | Item | EnumParam | OotbEnum | undefined;

export function getEnumValue<T extends string = string>(enumItem: EnumOrItem): T | undefined {
  const itemAsEnum = enumItem as Data.Enums.Gmienum | undefined;
  const ootbEnum = enumItem as OotbEnum | undefined;
  const item = enumItem as Item | undefined;
  const enumParam = enumItem as EnumParam | undefined;
  return (itemAsEnum?.fields?.value?.value ??
    ootbEnum?.fields?.Value?.value ??
    item?.name ??
    enumParam?.value?.value) as T | undefined;
}

export function getEnumValues<T extends string = string>(enumItems: EnumOrItem[] | undefined): T[] {
  return enumItems?.map(getEnumValue).filter((value): value is T => value !== undefined) ?? [];
}
